export const ModalWrapperBackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 9.99935H17.5H2.5Z" fill="#111928" />
    <path
      d="M8.33333 15.8327L2.5 9.99935M2.5 9.99935L8.33333 4.16602M2.5 9.99935H17.5"
      stroke="#111928"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
